// extracted by mini-css-extract-plugin
export default {"header":"FullScreenWidgetHeader_header__1UuJV"};